import { loadable } from 'nordic/lazy';
import compatsWidget from './compats-widget';

const CompatsWidget = loadable(() => import('../../../../components/compats-widget/container'));

export default compatsWidget(CompatsWidget);
